// Shared role metadata for DSV use-case-persona links.
//
//   value      — the `deType` stored on each DataElementPersona row
//                (matches EnrolmentTypes in src/constants/use-case/enrolment.js)
//   label      — human-facing label shown in the link modal + the links list
//   payloadKey — key used in the saveUseCasePersona `dataElements` payload
//
// Kept in one place so the link modal and the detail-page links list render the
// exact same approved copy/order instead of duplicating the map.
const ROLE_OPTIONS = [
	{ value: "PROVIDER", label: "Provider", payloadKey: "producedBy" },
	{ value: "PROVIDE_ON_BEHALF", label: "Provide on behalf", payloadKey: "provideOnBehalf" },
	{ value: "PROVIDE_ON_BEHALF_OF_PRINCIPAL", label: "Provide on behalf of principal", payloadKey: "provideOnBehalfOfPrincipal" },
	{ value: "CONSUMER", label: "Consumer", payloadKey: "consumedBy" },
	{ value: "CONSUME_ON_BEHALF", label: "Consume on behalf", payloadKey: "consumeOnBehalf" },
	{ value: "CONSUME_ON_BEHALF_OF_PRINCIPAL", label: "Consume on behalf of principal", payloadKey: "consumeOnBehalfOfPrincipal" },
];

const ROLE_LABEL_BY_VALUE = ROLE_OPTIONS.reduce((acc, role) => {
	acc[role.value] = role.label;
	return acc;
}, {});

/**
 * Human-facing label for a stored `deType`. Falls back to the raw value when the
 * type is unrecognised so the UI always shows something rather than blank.
 * @param {string} deType
 * @returns {string}
 */
function roleLabel(deType) {
	if (!deType) return "";
	return ROLE_LABEL_BY_VALUE[deType] || deType;
}

export { ROLE_OPTIONS, ROLE_LABEL_BY_VALUE, roleLabel };
